import React, { useEffect, useMemo, useState } from 'react';
import { Groupper, Icon } from 'react-frontier';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

interface QueueFinishProps{
	
}

var QueueFinish = (props: QueueFinishProps)=>{
	var { t } = useTranslation();
	var params = useParams<{ token: string }>();
	var [loadError, setLoadError] = useState<string>(null);

	var valid_params = useMemo(()=>{
		return params && params.token && params.token.length>=32;
	}, [params?.token]);

	useEffect(()=>{
		if(!params || !params.token || params.token.length<32) return;
		
	}, []);
	
	return <div className="ca finish-screen">
		<Groupper title={t('common.queue')} titleCentered>
			<div className="contents">
				{(!valid_params || loadError) ? <>
					<div className="marker error">
						<Icon name='triangle-exclamation' />
					</div>
					<div className="title">
						{t('common.error')}
					</div>
					<div className="description error">
						{!valid_params ? (
							t('wait.invalid_token')
						) : loadError}
					</div>
				</> : <>
					<div className="marker green">
						<Icon name='hands-clapping' />
					</div>
					<div className="title">
						{t('finish.title')}
					</div>
					<div className="description">
						<Trans i18nKey={'finish.description'} />
					</div>
					<div className="fr inline loading"></div>
				</>}
			</div>
		</Groupper>
	</div>
}

export default QueueFinish;